import React from "react";
import { RadialBarChart, RadialBar, ResponsiveContainer, PolarAngleAxis } from "recharts";
import Icon from "components/AppIcon";

export default function SatisfactionGauge({ data }) {
  if (!data?.score || data?.score === null) {
    return (
      <div
        className="card-base flex flex-col gap-3 min-w-0"
        style={{ background: "var(--color-card)", borderRadius: "var(--radius-md)" }}
      >
        <div className="flex items-center justify-between gap-2">
          <h3 className="font-heading font-semibold text-sm md:text-base" style={{ color: "var(--color-foreground)" }}>
            Customer Satisfaction
          </h3>
          <Icon name="Smile" size={18} color="var(--color-text-secondary)" />
        </div>
        <div className="flex flex-col items-center justify-center gap-2 py-8">
          <Icon name="BarChart2" size={20} color="var(--color-text-secondary)" />
          <p className="font-caption text-sm" style={{ color: "var(--color-text-secondary)" }}>
            No satisfaction data yet
          </p>
        </div>
      </div>
    );
  }

  const score = data?.score;
  const previousScore = data?.previousScore ?? score;
  const change = previousScore === null || previousScore === undefined ? null : score - previousScore;
  const color = score >= 80 ? "var(--color-success)" : score >= 60 ? "var(--color-warning)" : "var(--color-error)";

  const chartData = [{ value: score, fill: color }];
  const promoters = data?.promotersPercent ?? null;
  const passives = data?.passivesPercent ?? null;
  const detractors = data?.detractorsPercent ?? null;

  return (
    <div
      className="card-base flex flex-col gap-3 min-w-0"
      style={{ background: "var(--color-card)", borderRadius: "var(--radius-md)" }}
    >
      <div className="flex items-center justify-between gap-2">
        <h3 className="font-heading font-semibold text-sm md:text-base" style={{ color: "var(--color-foreground)" }}>
          Customer Satisfaction
        </h3>
        <Icon name="Smile" size={18} color={color} />
      </div>
      <div className="flex flex-col items-center gap-2">
        <div style={{ width: "100%", height: "160px", position: "relative" }}>
          <ResponsiveContainer width="100%" height="100%">
            <RadialBarChart
              cx="50%"
              cy="75%"
              innerRadius="65%"
              outerRadius="90%"
              startAngle={180}
              endAngle={0}
              data={chartData}
            >
              <PolarAngleAxis type="number" domain={[0, 100]} angleAxisId={0} tick={false} />
              <RadialBar
                background={{ fill: "var(--color-muted)" }}
                dataKey="value"
                angleAxisId={0}
                cornerRadius={6}
              />
            </RadialBarChart>
          </ResponsiveContainer>
          <div
            className="absolute flex flex-col items-center"
            style={{ bottom: "8px", left: "50%", transform: "translateX(-50%)" }}
          >
            <span
              className="font-heading font-bold"
              style={{ fontSize: "2rem", color: "var(--color-foreground)", lineHeight: 1 }}
            >
              {score}
            </span>
            <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>
              / 100 NPS
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2 w-full justify-center">
          {change !== null && (
            <div
              className="flex items-center gap-1 px-2 py-0.5 rounded"
              style={{ background: `${color}15` }}
            >
              <Icon name={change >= 0 ? "TrendingUp" : "TrendingDown"} size={12} color={color} strokeWidth={2.5} />
              <span className="font-data text-xs font-semibold" style={{ color }}>
                {change >= 0 ? "+" : ""}{change} pts
              </span>
            </div>
          )}
          <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>
            vs last quarter
          </span>
        </div>

        <div className="w-full grid grid-cols-3 gap-2 pt-2 border-t" style={{ borderColor: "var(--color-border)" }}>
          {[
              { label: "Promoters", value: promoters !== null ? `${promoters}%` : "—", color: "var(--color-success)" },
              { label: "Passives", value: passives !== null ? `${passives}%` : "—", color: "var(--color-warning)" },
              { label: "Detractors", value: detractors !== null ? `${detractors}%` : "—", color: "var(--color-error)" },
          ]?.map((item) => (
            <div key={item?.label} className="flex flex-col items-center gap-0.5">
              <span className="font-data text-sm font-bold" style={{ color: item?.color }}>{item?.value}</span>
              <span className="font-caption text-xs text-center" style={{ color: "var(--color-text-secondary)" }}>{item?.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}